$(document).ready(function () {

    $('.js-request-sample').on('click', function () {

        //Get content
        var url = "../../php/ajax/form.php?action=request-sample";

        var post_data = {};

        $.post(url, post_data, function (data) {

            try {
                var response = JSON.parse(data);

                //Add to page and display
                dialogify(response.html, {
                    buttons: {},
                    classes: {
                        "ui-dialog": "dialog js-sample-dialog",
                        "ui-dialog-titlebar": "dialog__titlebar",
                        "ui-dialog-buttonpane": "dialog__buttons",
                        "ui-dialog-content": "dialog__text",
                        "ui-dialog-buttonset": "dialog__buttons-inner"
                    }
                });
            } catch (e) {
                var msg = "ERROR: " + e + '<br /><br /> DATA:' + data;
                dialogify(msg);
            }


        });
    });

});